import { Component, Input, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ExportExcelService } from '../../../../shared/excel-service/export-excel.service';

@Component({
  selector: 'app-regional',
  templateUrl: './regional.component.html',
  styleUrls: ['./regional.component.scss']
})
export class RegionalComponent implements OnChanges {

  @Input() dadosGrid: any[] = [];
  @Input() loading: boolean = false;
  @Input() tipoRelatorio: 'regional' | 'faturamentoDiario' = 'regional';

  dados: any[] = [];
  totalizador: any = {};
  familiasUnicasOrdenadas: string[] = [];
  
  // Estado para controlar a expansão/colapso dos grupos regionais
  private regionCollapsedState = new Map<string, boolean>();
  
  // Estados para controlar se as colunas estão fixadas
  isDealerColumnFixed: boolean = false;
  isLastMonthStkColumnFixed: boolean = false;
  isShowroomColumnFixed: boolean = false;
  
  // Propriedades computadas para evitar re-renderização
  private _familiasUnicasCache: string[] = [];
  private _colunasFixasAtivasCache: any[] = [];
  private _colunasFamiliaAtivasCache: any[] = [];

  colunasFixas = [
    { field: 'name', header: 'Dealer', width: 350 },
    { field: 'lastMonthStk', header: 'Last Month STK', width: 150 }, 
    { field: 'showroomTraffic', header: 'Showroom', width: 130 }
  ];

  colunasFamilia = [
    { field: 'leads', header: 'Leads', width: 80 },
    { field: 'tgt', header: 'TGT', width: 80 },
    { field: 'stkDaysCover', header: 'STK Days Covere', width: 120 },
    { field: 'inventory', header: 'Inventory', width: 100 },
    { field: 'orderGAC', header: 'Pedido', width: 100 },
    { field: 'sales', header: 'Proposta', width: 100 },
    { field: 'retailInvoice', header: 'Faturamento', width: 120 }
  ];

  colunasFamiliaTotal = [
    { field: 'leads', header: 'Leads', width: 80 },
    { field: 'tgt', header: 'TGT', width: 80 },
    { field: 'stkDaysCover', header: 'STK Days Covere', width: 120 },
    { field: 'inventory', header: 'Inventory', width: 100 },
    { field: 'visitouShowroom', header: 'Cliente visitou loja', width: 140 },
    { field: 'testDrive', header: 'Test-drive', width: 120 },
    { field: 'orderGAC', header: 'Pedido', width: 100 },
    { field: 'sales', header: 'Proposta', width: 100 },
    { field: 'retailInvoice', header: 'Faturamento', width: 120 },
    { field: 'cancelamentoDevolucao', header: 'Cancel/Devol', width: 170},
    { field: 'varejo', header: 'Varejo', width: 120 },
    { field: 'vendaDireta', header: 'Venda Direta', width: 120 }
  ];

  constructor(
    private translate: TranslateService,
    private excelService: ExportExcelService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dadosGrid'] && this.dadosGrid) {
      this.processarDados();
    }
  }



  private processarDadosAPI(dadosAPI: any[]): any[] {
    return dadosAPI;
  }

  private limparDadosGrid() {
    this.dados = [];
    this.totalizador = {};
    this.familiasUnicasOrdenadas = [];
    this.regionCollapsedState.clear();
    this.invalidarCaches();
  }

  private invalidarCaches() {
    this._familiasUnicasCache = [];
    this._colunasFixasAtivasCache = [];
    this._colunasFamiliaAtivasCache = [];
  }

  get colunasFixasAtivas() {
    if (this._colunasFixasAtivasCache.length === 0) {
      this.atualizarColunasFixasAtivas();
    }
    return this._colunasFixasAtivasCache;
  }

  private atualizarColunasFixasAtivas() {
    if (this.tipoRelatorio === 'regional') {
      this._colunasFixasAtivasCache = [
        { field: 'name', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.dealer'), width: this.colunasFixas[0].width },
        { field: 'lastMonthStk', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.lastMonthStk'), width: this.colunasFixas[1].width }, 
        { field: 'showroomTraffic', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.showroomTraffic'), width: this.colunasFixas[2].width }
      ];
    } else {
      this._colunasFixasAtivasCache = [
        { field: 'name', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.dealer'), width: this.colunasFixas[0].width },
        { field: 'showroomTraffic', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.showroomTraffic'), width: this.colunasFixas[2].width }
      ];
    }
  }

  get colunasFamiliaAtivas() {
    if (this._colunasFamiliaAtivasCache.length === 0) {
      this.atualizarColunasFamiliaAtivas();
    }
    return this._colunasFamiliaAtivasCache;
  }

  get colunasFamiliaTotalAtivas() {
    if (this.tipoRelatorio === 'regional') {
      return [
        { field: 'leads', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.leads'), width: this.colunasFamiliaTotal[0].width },
        { field: 'tgt', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.tgt'), width: this.colunasFamiliaTotal[1].width },
        { field: 'stkDaysCover', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.stkDaysCover'), width: this.colunasFamiliaTotal[2].width },
        { field: 'inventory', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.inventory'), width: this.colunasFamiliaTotal[3].width },
        { field: 'visitouShowroom', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.clientesLoja'), width: this.colunasFamiliaTotal[4].width },
        { field: 'testDrive', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.testDrive'), width: this.colunasFamiliaTotal[5].width },
        { field: 'orderGAC', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.orderGAC'), width: this.colunasFamiliaTotal[6].width },
        { field: 'sales', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.sales'), width: this.colunasFamiliaTotal[7].width },
        { field: 'retailInvoice', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.retailInvoice'), width: this.colunasFamiliaTotal[8].width },
        { field: 'cancelamentoDevolucao', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.canceladosDevolvidos'), width: this.colunasFamiliaTotal[9].width },
        { field: 'varejo', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.varejo'), width: this.colunasFamiliaTotal[10].width },
        { field: 'vendaDireta', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.vendaDireta'), width: this.colunasFamiliaTotal[11].width }

      ];
    } else {
      return [
        { field: 'leads', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.leads'), width: this.colunasFamiliaTotal[0].width },
        { field: 'orderGAC', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.orderGAC'), width: this.colunasFamiliaTotal[6].width },
        { field: 'sales', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.sales'), width: this.colunasFamiliaTotal[7].width },
        { field: 'retailInvoice', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.retailInvoice'), width: this.colunasFamiliaTotal[8].width },
        { field: 'cancelamentoDevolucao', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.canceladosDevolvidos'), width: this.colunasFamiliaTotal[9].width },
        { field: 'varejo', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.varejo'), width: this.colunasFamiliaTotal[10].width },
        { field: 'vendaDireta', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.vendaDireta'), width: this.colunasFamiliaTotal[11].width }

      ];
    }
  }

  private atualizarColunasFamiliaAtivas() {
    if (this.tipoRelatorio === 'regional') {
      this._colunasFamiliaAtivasCache = [
        { field: 'leads', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.leads'), width: this.colunasFamilia[0].width },
        { field: 'tgt', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.tgt'), width: this.colunasFamilia[1].width },
        { field: 'stkDaysCover', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.stkDaysCover'), width: this.colunasFamilia[2].width },
        { field: 'inventory', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.inventory'), width: this.colunasFamilia[3].width },
        { field: 'orderGAC', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.orderGAC'), width: this.colunasFamilia[4].width },
        { field: 'sales', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.sales'), width: this.colunasFamilia[5].width },
        { field: 'retailInvoice', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.retailInvoice'), width: this.colunasFamilia[6].width }
      ];
    } else {
      this._colunasFamiliaAtivasCache = [
        { field: 'leads', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.leads'), width: this.colunasFamilia[0].width },
        { field: 'orderGAC', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.orderGAC'), width: this.colunasFamilia[4].width },
        { field: 'sales', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.sales'), width: this.colunasFamilia[5].width },
        { field: 'retailInvoice', header: this.translate.instant('relatorioVeiculos.veiculoRegional.colunas.retailInvoice'), width: this.colunasFamilia[6].width }
      ];
    }
  }

  inserirTotalizadoresPorRegiao(dados: any[]): any[] {
    const agrupados: { [regiao: string]: any[] } = {};
    const resultado: any[] = [];

    for (const dealer of dados) {
      if (!dealer.regiao) {
        resultado.push(dealer);
        continue;
      }

      agrupados[dealer.regiao] = agrupados[dealer.regiao] || [];
      agrupados[dealer.regiao].push(dealer);
    }

    for (const regiao in agrupados) {
      const dealers = agrupados[regiao];
      resultado.push(...dealers);

      const subtotal = this.calcularSubtotalRegiao(regiao, dealers);
      resultado.push(subtotal);
    }

    return resultado;
  }

  private calcularSubtotalRegiao(regiao: string, dealers: any[]): any {
    const subtotal = {
      name: 'Total - ' + regiao,
      regiao: regiao,
      lastMonthStk: 0,
      showroomTraffic: 0,
      crPercentual: 0,
      leadsMarca: 0,
      familias: [] as any[],
      isTotalRegiao: true
    };

    const mapaFamilias = new Map<string, any>();
    let totalSalesFromAPI = 0;

    for (const dealer of dealers) {
      const lastMonthValue = dealer.lastMonthStk || 0;
      subtotal.lastMonthStk += lastMonthValue;
      subtotal.showroomTraffic += dealer.showroomTraffic || 0;
      subtotal.leadsMarca += dealer.leadsMarca || 0;

      const familiaTotal = dealer.familias?.find((f: any) => f.familia === 'TOTAL');
      const dealerTotalSalesFromAPI = familiaTotal?.sales || 0;
      totalSalesFromAPI += dealerTotalSalesFromAPI;

      for (const familia of dealer.familias || []) {
        const chave = familia.familia;
        if (!mapaFamilias.has(chave)) {
          mapaFamilias.set(chave, {
            familia: chave,
            leads: 0,
            tgt: 0, 
            stkDaysCover: 0, 
            inventory: 0,
            sales: 0,
            retailInvoice: 0,
            orderGAC: 0,
            vendaDireta: 0,
            cancelamentoDevolucao: 0
            ,
            varejo: 0,
            visitouShowroom: 0,
            testDrive: 0
          });
        }

        const totalFamilia = mapaFamilias.get(chave);
        
        totalFamilia.leads += familia.leads || 0;
        totalFamilia.tgt += familia.tgt || 0; 
        totalFamilia.stkDaysCover += familia.stkDaysCover || 0; 
        totalFamilia.inventory += familia.inventory || 0;
        totalFamilia.sales += familia.sales || 0;
        totalFamilia.retailInvoice += familia.retailInvoice || 0;
        totalFamilia.orderGAC += familia.orderGAC || 0;
        totalFamilia.vendaDireta += familia.vendaDireta || 0;
        totalFamilia.cancelamentoDevolucao += familia.cancelamentoDevolucao || 0;
        totalFamilia.varejo += familia.varejo || 0;
        if (chave === 'TOTAL') {
          totalFamilia.visitouShowroom += familia.visitouShowroom ?? dealer.visitouShowroom ?? 0;
          totalFamilia.testDrive += familia.testDrive ?? dealer.testDrive ?? 0;
        }
      }
    }

    subtotal.familias = Array.from(mapaFamilias.values());
    
    if (subtotal.showroomTraffic > 0) {
      subtotal.crPercentual = (totalSalesFromAPI / subtotal.showroomTraffic) * 100;
    } else {
      subtotal.crPercentual = 0;
    }

    return subtotal;
  }

  calcularTotalizador() {
    const dealers = this.dados.filter(d => !d.isTotalRegiao);
  
    const total = {
      lastMonthStk: 0,
      showroomTraffic: 0,
      crPercentual: 0,
      leadsMarca: 0,
      familiasTotais: [] as any[]
    };
  
    const familiasMap = new Map<string, any>();
    let totalSalesGeralFromAPI = 0;
  
    for (const dealer of dealers) {
      const lastMonthValue = dealer.lastMonthStk || 0;
      total.lastMonthStk += lastMonthValue; 
      total.showroomTraffic += dealer.showroomTraffic || 0;
      total.leadsMarca += dealer.leadsMarca || 0;
  
      const familiaTotal = dealer.familias?.find((f: any) => f.familia === 'TOTAL');
      const dealerTotalSalesFromAPI = familiaTotal?.sales || 0;
      totalSalesGeralFromAPI += dealerTotalSalesFromAPI;
  
      for (const familia of dealer.familias || []) {
        const chave = familia.familia;
  
        if (!familiasMap.has(chave)) {
          familiasMap.set(chave, {
            familia: chave,
            leads: 0,
            tgt: 0, 
            stkDaysCover: 0, 
            inventory: 0,
            sales: 0,
            retailInvoice: 0,
            orderGAC: 0,
            vendaDireta: 0,
            cancelamentoDevolucao: 0
            ,
            varejo: 0,
            visitouShowroom: 0,
            testDrive: 0
          });
        }
  
        const totalFamilia = familiasMap.get(chave);
        totalFamilia.leads += familia.leads || 0;
        
        if (this.tipoRelatorio === 'regional') {
          totalFamilia.tgt += familia.tgt || 0; 
          totalFamilia.stkDaysCover += familia.stkDaysCover || 0; 
          totalFamilia.inventory += familia.inventory || 0;
        }
        
        totalFamilia.sales += familia.sales || 0;
        totalFamilia.retailInvoice += familia.retailInvoice || 0;
        totalFamilia.orderGAC += familia.orderGAC || 0;
        totalFamilia.vendaDireta += familia.vendaDireta || 0;
        totalFamilia.cancelamentoDevolucao += familia.cancelamentoDevolucao || 0;
        totalFamilia.varejo += familia.varejo || 0;
        if (chave === 'TOTAL') {
          totalFamilia.visitouShowroom += familia.visitouShowroom ?? dealer.visitouShowroom ?? 0;
          totalFamilia.testDrive += familia.testDrive ?? dealer.testDrive ?? 0;
        }
      }
    }
  
    if (total.showroomTraffic > 0) {
      total.crPercentual = (totalSalesGeralFromAPI / total.showroomTraffic) * 100;
    } else {
      total.crPercentual = 0;
    }
  
    total.familiasTotais = Array.from(familiasMap.values());
    this.totalizador = total;
  }

  getValorTotalizador(familia: string, campo: string): number {
    const f = this.totalizador?.familiasTotais?.find(f => f.familia === familia);
    return f?.[campo] ?? 0;
  }

  get familiasUnicas(): string[] {
    if (this._familiasUnicasCache.length === 0 && this.dados.length > 0) {
      this.atualizarFamiliasUnicas();
    }
    return this._familiasUnicasCache;
  }

  private atualizarFamiliasUnicas() {
    const set = new Set<string>();
    this.dados.forEach((d) =>
      d.familias.forEach((f: any) => set.add(f.familia))
    );

    this._familiasUnicasCache = Array.from(set).sort((a, b) => {
      if (a === 'TOTAL') return 1;
      if (b === 'TOTAL') return -1;
      return a.localeCompare(b);
    });
  }

  getFamiliaData(dealer: any, familia: string) {
    return dealer.familias.find((f: any) => f.familia === familia) || {};
  }

  getValorColunaFamiliaTotal(dealer: any, col: { field: string }): number {
    const familiaData = this.getFamiliaData(dealer, 'TOTAL');
    if (col.field === 'visitouShowroom') {
      return familiaData.visitouShowroom ?? dealer.visitouShowroom ?? 0;
    }
    if (col.field === 'testDrive') {
      return familiaData.testDrive ?? dealer.testDrive ?? 0;
    }
    return familiaData[col.field] || 0;
  }

  get isRelatorioMensal(): boolean {
    return this.tipoRelatorio === 'regional';
  }

  // TrackBy functions para otimizar performance
  trackByFamiliaIndex(index: number, familia: string): string {
    return familia;
  }

  trackByColIndex(index: number, col: any): string {
    return col.field;
  }

  trackByDealerName(index: number, dealer: any): string {
    return dealer.name || index.toString();
  }

  // Método para ajustar largura das colunas
  ajustarLarguraColuna(tipo: 'fixa' | 'familia', campo: string, novaLargura: number): void {
    if (tipo === 'fixa') {
      const coluna = this.colunasFixas.find(col => col.field === campo);
      if (coluna) {
        coluna.width = novaLargura;
        this.invalidarCaches();
        this.cdr.detectChanges(); // Forçar atualização da view
      }
    } else {
      const coluna = this.colunasFamilia.find(col => col.field === campo);
      if (coluna) {
        coluna.width = novaLargura;
        this.invalidarCaches();
        this.cdr.detectChanges(); // Forçar atualização da view
      }
    }
  }

  // Método para obter largura de uma coluna
  obterLarguraColuna(tipo: 'fixa' | 'familia', campo: string): number {
    if (tipo === 'fixa') {
      const coluna = this.colunasFixas.find(col => col.field === campo);
      return coluna?.width || 150;
    } else {
      const coluna = this.colunasFamilia.find(col => col.field === campo);
      return coluna?.width || 120;
    }
  }


  // Método para gerar classes CSS das linhas
  getRowClasses(dealer: any): any {
    return {
      'total-regiao': dealer.isTotalRegiao,
      'dealer-row': !dealer.isTotalRegiao
    };
  }

  // Métodos para controlar expansão/colapso dos grupos regionais
  toggleRegionCollapse(regiao: string): void {
    const currentState = this.regionCollapsedState.get(regiao) || false;
    this.regionCollapsedState.set(regiao, !currentState);
  }

  isRegionCollapsed(regiao: string): boolean {
    return this.regionCollapsedState.get(regiao) || false;
  }

  shouldShowDealer(dealer: any, index: number): boolean {
    if (dealer.isTotalRegiao) {
      return true; // Sempre mostrar totalizadores regionais
    }

    // Para dealers normais, verificar se a região está expandida
    const regiao = dealer.regiao;
    if (regiao) {
      return !this.isRegionCollapsed(regiao);
    }

    // Se não tem região definida, mostrar por padrão
    return true;
  }

  getRegionIconClass(regiao: string): string {
    return this.isRegionCollapsed(regiao) ? 'pi pi-chevron-right' : 'pi pi-chevron-up';
  }

  getHeaderIconClass(): string {
    return this.areAllRegionsExpanded() ? 'pi pi-eye' : 'pi pi-eye-slash';
  }

  getColumnAlignment(field: string): string {
    switch (field) {
      case 'name':
        return 'left';
      case 'lastMonthStk':
      case 'showroomTraffic':
        return 'center';
      default:
        return 'center';
    }
  }

  expandAllRegions(): void {
    const regioes = this.getUniqueRegions();
    regioes.forEach(regiao => this.regionCollapsedState.set(regiao, false));
  }

  collapseAllRegions(): void {
    const regioes = this.getUniqueRegions();
    regioes.forEach(regiao => this.regionCollapsedState.set(regiao, true));
  }

  toggleAllRegions(): void {
    if (this.areAllRegionsExpanded()) {
      this.collapseAllRegions();
    } else {
      this.expandAllRegions();
    }
  }
  
  areAllRegionsExpanded(): boolean {
    const regioes = this.getUniqueRegions();
    if (regioes.length === 0) return false;
    
    return regioes.every(regiao => !this.isRegionCollapsed(regiao));
  }

  private getUniqueRegions(): string[] {
    const regioes = new Set<string>();
    this.dados.forEach(dealer => {
      if (dealer.regiao) {
        regioes.add(dealer.regiao);
      }
    });
    return Array.from(regioes);
  }

  // Métodos para alternar fixação das colunas
  toggleDealerColumnFixed(): void {
    this.isDealerColumnFixed = !this.isDealerColumnFixed;
  }

  toggleLastMonthStkColumnFixed(): void {
    this.isLastMonthStkColumnFixed = !this.isLastMonthStkColumnFixed;
  }

  toggleShowroomColumnFixed(): void {
    this.isShowroomColumnFixed = !this.isShowroomColumnFixed;
  }

  // Métodos para obter classes CSS das colunas
  getDealerColumnClass(): string {
    return this.isDealerColumnFixed ? 'fixed-dealer-column' : '';
  }

  getLastMonthStkColumnClass(): string {
    return this.isLastMonthStkColumnFixed ? 'fixed-lastmonthstk-column' : '';
  }

  getShowroomColumnClass(): string {
    return this.isShowroomColumnFixed ? 'fixed-showroom-column' : '';
  }

  // Métodos para obter ícones dos botões de fixação
  getDealerColumnIconClass(): string {
    return this.isDealerColumnFixed ? 'pi pi-lock' : 'pi pi-lock-open';
  }

  getLastMonthStkColumnIconClass(): string {
    return this.isLastMonthStkColumnFixed ? 'pi pi-lock' : 'pi pi-lock-open';
  }

  getShowroomColumnIconClass(): string {
    return this.isShowroomColumnFixed ? 'pi pi-lock' : 'pi pi-lock-open';
  }

  // Métodos para calcular posição dinâmica das colunas fixadas
  getFixedColumnPosition(field: string): number {
    const fixedColumns = this.getFixedColumnsInOrder();
    const index = fixedColumns.indexOf(field);
    
    if (index === -1) return 0; // Não está fixada
    
    let position = 0;
    for (let i = 0; i < index; i++) {
      const colField = fixedColumns[i];
      position += this.getColumnWidth(colField);
    }
    
    // Mover LastMonthSTK 1px para a esquerda e Showroom 2px para a esquerda quando fixadas
    if (field === 'lastMonthStk') {
      position -= 1;
    } else if (field === 'showroomTraffic') {
      position -= 2;
    }
    
    return position;
  }

  private getFixedColumnsInOrder(): string[] {
    const fixedColumns: string[] = [];
    
    // Ordem original das colunas
    const columnOrder = ['name', 'lastMonthStk', 'showroomTraffic'];
    
    columnOrder.forEach(field => {
      if (this.isColumnFixed(field)) {
        fixedColumns.push(field);
      }
    });
    
    return fixedColumns;
  }

  private isColumnFixed(field: string): boolean {
    switch (field) {
      case 'name':
        return this.isDealerColumnFixed;
      case 'lastMonthStk':
        return this.isLastMonthStkColumnFixed;
      case 'showroomTraffic':
        return this.isShowroomColumnFixed;
      default:
        return false;
    }
  }

  private getColumnWidth(field: string): number {
    switch (field) {
      case 'name':
        return 350;
      case 'lastMonthStk':
        return 150; // Aumentado de 120 para 150
      case 'showroomTraffic':
        return 130;
      default:
        return 150;
    }
  }

  private processarDados() {
    if (this.dadosGrid && this.dadosGrid.length > 0) {
      const dadosProcessados = this.processarDadosAPI(this.dadosGrid);
      const dadosSemTotal = dadosProcessados.filter(d => d.name !== 'TOTAL');

      this.dados = this.inserirTotalizadoresPorRegiao(dadosSemTotal);
      this.calcularTotalizador();

      const set = new Set<string>();
      this.dados.forEach((d) =>
        d.familias.forEach((f: any) => set.add(f.familia))
      );
      this.familiasUnicasOrdenadas = Array.from(set).sort((a, b) => {
        if (a === 'TOTAL') return 1;
        if (b === 'TOTAL') return -1;
        return a.localeCompare(b);
      });

      this.invalidarCaches();
    } else {
      this.limparDadosGrid();
    }
  }
}